import { render, staticRenderFns } from "./titleBar.vue?vue&type=template&id=1aba544e&scoped=true"
import script from "./titleBar.vue?vue&type=script&lang=js"
export * from "./titleBar.vue?vue&type=script&lang=js"
import style0 from "./titleBar.vue?vue&type=style&index=0&id=1aba544e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba544e",
  null
  
)

export default component.exports